/* eslint-disable max-lines-per-function */
import {
  Button,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui';
import { ResultList } from '@/domain/navigation/features/search/components/ResultList';
import { useDebounce } from '@/domain/navigation/features/search/hooks/useDebounce';
import {
  faMagnifyingGlass,
  faSearch,
  faSpinnerThird,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSearch from '@/domain/navigation/features/search/hooks/useSearch';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export function Search() {
  const [query, setQuery] = useState('');
  const debouncedQ = useDebounce(query, 300);
  const [open, setOpen] = useState(false);

  const { loading, standortResults } = useSearch(debouncedQ);
  const { t } = useTranslation();

  return (
    <Popover
      open={open}
      onOpenChange={(open) => {
        setQuery('');
        setOpen(open);
      }}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="size-8">
          <FontAwesomeIcon icon={faSearch} className="text-neutrals-800" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        className="bg-neutrals-100 p-3 w-80 shadow-md shadow-neutrals-1000/10">
        <div className="flex flex-col h-full justify-start gap-4">
          <Input
            autoFocus
            className="border-none py-0"
            startIcon={faMagnifyingGlass}
            onChange={(e) => {
              setQuery(e.currentTarget.value);
            }}
            placeholder={t('domain.navigation.suche.placeholder')}></Input>
          {loading && (
            <div className="flex w-full justify-center items-center h-full">
              <FontAwesomeIcon
                className="text-primary-blue-600 "
                size="2xl"
                icon={faSpinnerThird}
                spin
              />
            </div>
          )}
          {!loading && (
            <ResultList
              handleClose={(e) => {
                setQuery('');
                setOpen(e);
              }}
              results={standortResults}
            />
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
